import { ThemeToggleWrapper } from "@/components/wrappers";
import { useDashboardContext } from "@/layouts/dashboard-layout";
import { BsFillSunFill, BsFillMoonFill } from "react-icons/bs";

const ThemeToggle = () => {
  const { isDarkTheme, toggleTheme } = useDashboardContext();

  return <ThemeToggleWrapper onClick={toggleTheme}>{isDarkTheme ? <BsFillSunFill className="toggle-icon" /> : <BsFillMoonFill className="toggle-icon" />}</ThemeToggleWrapper>;
};

export default ThemeToggle;
